import styled from 'styled-components';
import { devices } from 'signup-constants/styles/viewports.styles';
export const StyledIllustration = styled.div.withConfig({
  displayName: "Messagingstyles__StyledIllustration"
})(["display:block;@media ", "{display:block;}"], devices.desktop);